import { render, staticRenderFns } from "./YtDiscoverImportCard.vue?vue&type=template&id=3d45dd67&scoped=true&"
import script from "./YtDiscoverImportCard.vue?vue&type=script&lang=js&"
export * from "./YtDiscoverImportCard.vue?vue&type=script&lang=js&"
import style0 from "./YtDiscoverImportCard.vue?vue&type=style&index=0&id=3d45dd67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d45dd67",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
